<script setup lang="ts">
import { useCurrencyFormatter } from '~/shared-kernel/presentation/composables/useCurrencyFormatter'

const props = defineProps<{
  total: { amount: number; currency: string } | null
  disabled: boolean
}>()

const emit = defineEmits<{
  continue: []
}>()

const { t } = useI18n()
const { formatMoney } = useCurrencyFormatter()
</script>

<template>
  <div class="public-purchase-cart__summary">
    <div>
      <span>{{ t('public.purchase.cartTotal') }}</span>
      <strong v-if="props.total">{{ formatMoney(props.total.amount, props.total.currency) }}</strong>
      <strong v-else>—</strong>
    </div>
    <TqButton
      :disabled="props.disabled"
      icon="i-lucide-arrow-right"
      @click="emit('continue')"
    >
      {{ t('public.purchase.continueToCheckout') }}
    </TqButton>
  </div>
</template>

<style scoped>
.public-purchase-cart__summary {
  display: grid;
  gap: 1rem;
}

.public-purchase-cart__summary span {
  color: var(--tq-text-soft);
}

.public-purchase-cart__summary > div:first-child {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
}

.public-purchase-cart__summary > div:first-child strong {
  color: var(--tq-text);
  font-size: 1.35rem;
}
</style>
